import {
  GET_AGENTS,
  SET_AGENTS,
  GET_AGENTS_FAILED,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILED,
} from 'store/geolocAgent/constants';
import {
  ActionWithPayloadType,
  ActionWithoutPayloadType,
} from 'store/geolocAgent/types';
const setAgents = (payload: any): SetAgentsType => ({
  type: SET_AGENTS,
  payload,
});
const getAgents = (): getAgentsType => ({
  type: GET_AGENTS,
});
const getAgentsFailed = (payload: any): SetAgentsTypeFailed => ({
  type: GET_AGENTS_FAILED,
  payload,
});

const getCities = (cityName: string): GetCities => ({
  type: GET_CITIES,
  payload: cityName,
});

const getCitiesSuccess = (cities: any): GetCitiesSuccess => ({
  type: GET_CITIES_SUCCESS,
  payload: cities,
});

const getCitiesFailed = (errorMessage: string): GerCitiesFailed => ({
  type: GET_CITIES_FAILED,
  payload: errorMessage,
});

type SetAgentsType = ActionWithPayloadType<typeof SET_AGENTS, string>;
type SetAgentsTypeFailed = ActionWithPayloadType<
  typeof GET_AGENTS_FAILED,
  string
>;
type getAgentsType = ActionWithoutPayloadType<typeof GET_AGENTS>;
type GetCities = ActionWithPayloadType<typeof GET_CITIES, string>;
type GetCitiesSuccess = ActionWithPayloadType<typeof GET_CITIES_SUCCESS, any>;
type GerCitiesFailed = ActionWithPayloadType<typeof GET_CITIES_FAILED, string>;
export type geolocAgentActionType =
  | SetAgentsType
  | getAgentsType
  | SetAgentsTypeFailed
  | GetCities
  | GetCitiesSuccess
  | GerCitiesFailed;

export {
  setAgents,
  getAgents,
  getAgentsFailed,
  getCities,
  getCitiesSuccess,
  getCitiesFailed,
};
